import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import PopularPosts from "../components/popularPosts"

import "./sidebar.css"

const Sidebar = ({ className, children, banner }) => {
  const bannerTitles = number => {
    switch (number) {
      case 1:
        return "CDPならINTEGRAL-CORE"
        break
      case 2:
        return "専用アドサーバー「ADmiral」"
        break
      case 3:
        return 
        break
      case 4:
        return ""
        break
      case 5:
        return 
        break
      case 6:
        return 
        break
      }
  }
  const bannerLink = number => {
    switch (number) {
      case 1:
        return "https://www.ever-rise.co.jp/integral-core/resource/integral-core/"
        break
      case 2:
        return "https://www.ever-rise.co.jp/admiral/"
        break
      case 3:
        return ""
        break
      case 4:
        return ""
        break
      case 5:
        return ""
        break
      case 6:
        return ""
        break
      }
    }
  return (
    <div className="sidebar-scroll">
    <div className={`${!!className ? className : ""}`}>
      {!!children ? children : null}
      {/* <PopularPosts /> */}
      {banner && banner.length > 0 && (
        <div className="mt-4 mb-10 lg:mb-8">
          {/* Reproでバナー表示をおこなう場合はdivの枠だけ生成する */
          banner.map(number => (
            <div id={`banner-${number}`}></div>
          ))}
          {/* banner.map(number => (
            <div id={`banner-${number}`} className="mb-6">
              <div className="text-textGray-100 w-full flex gap-1 lg:gap-3 items-center font-bold text-base lg:text-xl tracking-wide mb-2">
                {bannerTitles(number)}
              </div>
              <a href={bannerLink(number)} target="_blank">
                {number === 1 && (
                  <StaticImage
                    layout="fullWidth"
                    src={`../images/banner-1.png`}
                  />
                )}
                {number === 2 && (
                  <StaticImage
                    layout="fullWidth"
                    src={`../images/banner-2.png`}
                  />
                )}
                {number === 3 && (
                  <StaticImage
                    layout="fullWidth"
                    src={`../images/banner-3.png`}
                  />
                )}
                {number === 4 && (
                  <StaticImage
                    layout="fullWidth"
                    src={`../images/banner-4.png`}
                  />
                )}
                {number === 5 && (
                  <StaticImage
                    layout="fullWidth"
                    src={`../images/banner-5.png`}
                  />
                )}
                {number === 6 && (
                  <StaticImage
                    layout="fullWidth"
                    src={`../images/banner-6.png`}
                  />
                )}
                {number === 7 && (
                  <StaticImage
                    layout="fullWidth"
                    src={`../images/banner-7.png`}
                  />
                )}
              </a>
            </div>
          )) */}
        </div>
      )}
    </div>
    </div>
  )
}

export default Sidebar
